import {ChildEntity, Column} from "typeorm";
import {Incident} from "@/modules/match/entity/Incident";
import {NeutralIncidentTypeEnum} from "@/modules/match/enums";
import NeutralIncidentComponent from '@/modules/match/components/NeutralIncident.vue';
import NeutralIncidentLiveComponent from '@/modules/match/components/live-incident/NeutralIncident.vue';
import {Component, ShallowRef} from "vue";

@ChildEntity()
export class NeutralIncident extends Incident {
  @Column({type: 'varchar', enum: NeutralIncidentTypeEnum})
  neutralType: NeutralIncidentTypeEnum;

  get component(): ShallowRef<Component> {
    return shallowRef(NeutralIncidentComponent);
  }

  get liveComponent(): ShallowRef<Component> {
    return shallowRef(NeutralIncidentLiveComponent);
  }

  get fullWidth(): boolean {
    return [
      NeutralIncidentTypeEnum.NOT_ENOUGH_PlAYERS,
    ].includes(this.neutralType);
  }
}
